import React, { useEffect, useState } from 'react';

const InlineLoadingAnimation = ({ messages, onLoadingComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [dots, setDots] = useState('');

  // Effect to cycle through loading messages
  useEffect(() => {
    if (currentStep < messages.length - 1) {
      const timer = setTimeout(() => {
        setCurrentStep(prevStep => prevStep + 1);
      }, 1500);
      return () => clearTimeout(timer);
    } else {
      // Once all steps are shown, trigger the completion function after a short delay
      const completeTimer = setTimeout(() => {
        if (onLoadingComplete) {
          onLoadingComplete();
        }
      }, 2000);
      return () => clearTimeout(completeTimer);
    }
  }, [currentStep, messages.length, onLoadingComplete]);

  // Effect for the "..." typing animation
  useEffect(() => {
    const dotsTimer = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '' : prev + '.'));
    }, 400);
    return () => clearInterval(dotsTimer);
  }, []);

  return (
    <div className="text-center py-8 text-cyan-400 font-mono">
      <div className="inline-block relative">
        <h1
          className="text-2xl md:text-3xl font-bold glitch-text mb-4"
          data-text={messages[currentStep]}
        >
          {messages[currentStep]}
        </h1>
        <p className="text-lg animate-blink">
          {dots}
        </p>
      </div>
      
      {/* Cyberpunk elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="scanline-inline"></div>
        <div className="grid-pattern-inline"></div>
      </div>
    </div>
  );
};

export default InlineLoadingAnimation;
